(() => {
  document.documentElement.classList.add('izt-js');

  /* ---------- shipping dates: local calendar, recalculated every visit and at midnight ---------- */
  function fmtRange(now, start, end, locale) {
    const day = (n) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12);
    const a = day(start), b = day(Math.max(start, end));
    const opts = { month: 'short', day: 'numeric' };
    if (b.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
    const f = new Intl.DateTimeFormat(locale, opts);
    let text;
    if (start === end) text = f.format(a);
    else if (f.formatRange) text = f.formatRange(a, b);
    else text = f.format(a) + '–' + f.format(b);
    return { a, b, text };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(), loc = document.documentElement.lang || 'en-US';
    document.querySelectorAll('[data-izt-ship-date]').forEach((el) => {
      const s = Number(el.dataset.start), e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      const r = fmtRange(now, s, e, loc);
      el.textContent = r.text;
      const full = new Intl.DateTimeFormat(loc, { dateStyle: 'long' });
      el.setAttribute('aria-label', s === e ? full.format(r.a) : full.format(r.a) + ' to ' + full.format(r.b));
    });
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  window.addEventListener('pageshow', updateShipDates);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateShipDates(); });

  /* ---------- free gift: one gift line, free through its code, removed when no pack is in the cart ---------- */
  const Gift = (() => {
    let cfg = null, pending = null;
    const base = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    async function req(path, body, tries = 2) {
      const r = await fetch(base() + path, body
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
        : { headers: { Accept: 'application/json' } });
      let d;
      try { d = JSON.parse(await r.text()); }
      catch (e) {
        if (tries > 1) { await new Promise((z) => setTimeout(z, 500)); return req(path, body, tries - 1); }
        throw Error('Your cart is busy. Please try again in a moment.');
      }
      if (!r.ok || d.status) throw Error(d.description || d.message || 'Your cart could not be updated. Please try again.');
      return d;
    }
    async function reconcile() {
      if (!cfg || !cfg.gift) return null;
      let cart = await req('cart.js');
      const isPack = (i) => cfg.packs.includes(Number(i.variant_id));
      const gifts = cart.items.filter((i) => Number(i.variant_id) === cfg.gift);
      const want = cart.items.some(isPack) ? 1 : 0;
      const have = gifts.reduce((n, i) => n + i.quantity, 0);
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const own = cfg.code.toUpperCase();
      const others = codes.filter((c) => c.toUpperCase() !== own);
      const applied = codes.some((c) => c.toUpperCase() === own);
      const free = gifts.every((i) => i.final_line_price === 0);
      if (have === want && (want === 0 ? !applied : applied && free)) return cart;
      const updates = {};
      if (gifts.length) gifts.forEach((g, k) => (updates[g.key] = k === 0 ? want : 0));
      else if (want) updates[cfg.gift] = want;
      const drawer = document.querySelector('cart-drawer');
      const sections = (drawer && drawer.getSectionsToRender && drawer.getSectionsToRender().map((s) => s.id)) || [];
      cart = await req('cart/update.js', { updates, discount: [...others, ...(want ? [cfg.code] : [])].join(','), sections, sections_url: location.pathname });
      const charged = cart.items.filter((i) => Number(i.variant_id) === cfg.gift && i.final_line_price > 0);
      if (want && charged.length) {
        const rm = {};
        charged.forEach((i) => (rm[i.key] = 0));
        cart = await req('cart/update.js', { updates: rm, sections, sections_url: location.pathname });
        if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
        throw Error('Your ties are in your toolbox, but the free trim tools could not be applied. Please contact us before checkout.');
      }
      if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
      return cart;
    }
    return {
      set(c) { cfg = c; },
      sync() { return pending || ((pending = reconcile().finally(() => (pending = null))), pending); }
    };
  })();
  window.IztGift = Gift;

  const reduce = () => matchMedia('(prefers-reduced-motion:reduce)').matches;

  function initReveal() {
    const secs = document.querySelectorAll('.iz-s[data-izt-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      }), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      secs.forEach((s) => io.observe(s));
    } else secs.forEach((s) => s.classList.add('is-in'));
    const catchUp = () => secs.forEach((s) => { if (s.getBoundingClientRect().top < innerHeight) s.classList.add('is-in'); });
    addEventListener('scroll', () => requestAnimationFrame(catchUp), { passive: true });
    catchUp();
  }

  function init() {
    updateShipDates();
    initReveal();
    const root = document.querySelector('#izt');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.iz-proof .ceyla-rproof__text').forEach((pEl) => pEl.childNodes.forEach((n) => {
      if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' ';
    }));

    const money = (c) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(c / 100);
    const tiers = [...root.querySelectorAll('[name="izt-tier"]')];
    const addons = [...root.querySelectorAll('[data-izt-addon]')];
    const top = tiers.length ? Number(tiers[tiers.length - 1].value) : 4;
    const tierInfo = (t) => {
      const r = tiers.find((x) => x.value === String(t)) || tiers[0];
      return {
        r, variant: Number(r.dataset.variant), price: Number(r.dataset.price), compare: Number(r.dataset.compare || 0),
        qty: Number(r.dataset.qty), per: Number(r.dataset.per), fixes: Number(r.dataset.fixes), media: r.dataset.media,
        available: r.dataset.available === 'true'
      };
    };
    Gift.set({ packs: tiers.map((r) => Number(r.dataset.variant)), gift: Number(root.dataset.giftVariant) || 0, code: root.dataset.giftCode || 'TIEGIFT' });

    /* gallery */
    const g = root.querySelector('[data-izt-gallery]');
    const slides = [...g.querySelectorAll('.iz-slide')];
    const thumbs = [...root.querySelectorAll('.iz-thumb')];
    const smooth = () => (reduce() ? 'auto' : 'smooth');
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : g.clientWidth) || g.clientWidth;
    const idx = () => Math.max(0, Math.min(slides.length - 1, Math.round(g.scrollLeft / step())));
    const to = (i, instant) => g.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * step(), behavior: instant ? 'auto' : smooth() });
    root.querySelectorAll('[data-izt-slide]').forEach((b) => b.addEventListener('click', () => to(Number(b.dataset.iztSlide))));
    const nx = root.querySelector('[data-izt-next]'), pv = root.querySelector('[data-izt-prev]');
    if (nx) nx.addEventListener('click', () => to(idx() + 1));
    if (pv) pv.addEventListener('click', () => to(idx() - 1));
    let raf;
    g.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = idx(), ix = root.querySelector('[data-izt-index]');
        if (ix) ix.textContent = String(i + 1);
        thumbs.forEach((t, j) => { t.classList.toggle('is-on', i === j); t.setAttribute('aria-pressed', String(i === j)); });
        const at = thumbs[i], row = at && at.parentElement;
        if (row && row.scrollWidth > row.clientWidth) row.scrollTo({ left: at.offsetLeft - row.clientWidth / 2 + at.clientWidth / 2, behavior: smooth() });
        slides.forEach((sl, j) => { const v = sl.querySelector('video'); if (v) { if (j === i) v.play().catch(() => {}); else v.pause(); } });
      });
    }, { passive: true });
    g.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); to(idx() + (e.key === 'ArrowRight' ? 1 : -1)); }
    });

    /* pack ladder */
    let tier = Number(root.dataset.tier) || 1;
    const termsId = root.querySelector('[data-izt-terms-id]');
    const nudges = {};
    const tpl = root.querySelector('[data-izt-nudges]');
    if (tpl) tpl.content.querySelectorAll('[data-t]').forEach((s) => (nudges[s.dataset.t] = s.innerHTML));
    const teeth = [...root.querySelectorAll('.iz-strap-teeth i')];
    const cap = root.querySelector('[data-izt-cap]');
    const nudgeBox = root.querySelector('[data-izt-nudge]');
    const maxQty = tierInfo(top).qty || 200;
    const addonTotal = () => addons.reduce((n, a) => n + (a.checked ? Number(a.dataset.price) : 0), 0);

    const paint = (fromUser) => {
      const t = tierInfo(tier);
      tiers.forEach((r) => { r.checked = r.value === String(tier); r.closest('.iz-rung').classList.toggle('is-on', r.checked); });
      /* ratchet strap: one tooth per 10 ties, the locking cap slides to the last lit tooth */
      const lit = Math.max(1, Math.round((t.qty / maxQty) * teeth.length));
      let k = 0;
      teeth.forEach((d, i) => {
        const on = i < lit;
        if (on !== d.classList.contains('is-lit')) d.style.setProperty('--d', k++);
        d.classList.toggle('is-lit', on);
      });
      if (cap) cap.style.setProperty('--xn', String(lit / teeth.length));
      const set = (sel, v) => { const el = root.querySelector(sel); if (el) el.textContent = v; };
      set('[data-izt-ties]', t.qty);
      set('[data-izt-fixes]', t.fixes);
      set('[data-izt-per]', t.per + '¢ a tie');
      set('[data-izt-price]', money(t.price));
      const c = root.querySelector('[data-izt-compare]'), s = root.querySelector('[data-izt-save]');
      if (t.compare > t.price) {
        c.hidden = false; s.hidden = false;
        c.textContent = money(t.compare);
        s.textContent = 'Save ' + money(t.compare - t.price).replace(/\.00(?=\D*$)/, '');
      } else { c.hidden = true; s.hidden = true; }
      /* upgrade nudge */
      if (nudgeBox) {
        const nt = nudgeBox.querySelector('[data-izt-nudge-text]');
        if (nt && nudges[tier] !== undefined) nt.innerHTML = nudges[tier];
        nudgeBox.classList.toggle('is-top', tier === top);
        nudgeBox.dataset.tier = tier;
      }
      const total = t.price + addonTotal();
      document.querySelectorAll('[data-izt-atc-total]').forEach((el) => (el.textContent = money(total)));
      const sp = document.querySelector('[data-izt-sticky-price]');
      if (sp) sp.textContent = money(total);
      if (termsId && termsId.value !== String(t.variant)) {
        termsId.value = t.variant;
        termsId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const main = root.querySelector('.iz-atc[data-izt-add]');
      if (main) main.disabled = !t.available;
      document.querySelectorAll('[data-izt-kit-toggle]').forEach((b) => {
        const a = addons.find((x) => x.dataset.iztAddon === b.dataset.iztKitToggle);
        const on = !!(a && a.checked);
        b.setAttribute('aria-pressed', String(on));
        const sp2 = b.querySelector('span');
        if (sp2) sp2.textContent = on ? sp2.dataset.on : sp2.dataset.off;
      });
      if (fromUser) {
        if (t.variant) { const u = new URL(location.href); u.searchParams.set('variant', t.variant); history.replaceState(history.state, '', u); }
        if (t.media) {
          const si = slides.findIndex((sl) => sl.dataset.mediaId === t.media);
          if (si >= 0 && root.querySelector('.iz-buy').getBoundingClientRect().top < innerHeight) to(si);
        }
        const card = t.r.closest('.iz-rung');
        if (card && !reduce()) { card.classList.remove('is-snap'); void card.offsetWidth; card.classList.add('is-snap'); }
      }
    };
    tiers.forEach((r) => r.addEventListener('change', () => { tier = Number(r.value); paint(true); }));
    addons.forEach((a) => a.addEventListener('change', () => paint(false)));
    const up = root.querySelector('[data-izt-upgrade]');
    if (up) up.addEventListener('click', () => { tier = top; paint(true); const r = tierInfo(top).r; if (r) r.focus({ preventScroll: true }); });
    document.querySelectorAll('[data-izt-kit-toggle]').forEach((b) => b.addEventListener('click', () => {
      const a = addons.find((x) => x.dataset.iztAddon === b.dataset.iztKitToggle);
      if (a) { a.checked = !a.checked; paint(false); }
    }));
    paint(false);
    window.addEventListener('pageshow', () => paint(false));

    /* add to cart through the theme's native drawer */
    async function drawerReady() {
      await customElements.whenDefined('cart-drawer');
      const d = document.querySelector('cart-drawer');
      if (!d || typeof d.renderContents !== 'function') throw Error('The cart is still loading. Please try again.');
      return d;
    }
    const setCount = (n) => root.querySelectorAll('[data-izt-count]').forEach((e) => (e.textContent = n));
    const vipFirst = () => {
      const sheet = document.querySelector('.vf-root'), bag = document.querySelector('cart-drawer');
      if (!sheet || !bag || sheet.classList.contains('open')) return;
      const hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
      Object.keys(hide).forEach((p) => bag.style.setProperty(p, hide[p], 'important'));
      let ticks = 0;
      const tm = setInterval(() => {
        if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach((p) => bag.style.removeProperty(p)); }
      }, 100);
    };
    let busy = false;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget, t = tierInfo(tier);
      if (!t.available || !t.variant) return;
      busy = true;
      const buttons = [...document.querySelectorAll('[data-izt-add]')];
      buttons.forEach((b) => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const err = root.querySelector('[data-izt-error]');
      err.textContent = '';
      try {
        const drawer = await drawerReady();
        if (drawer.setActiveElement) drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map((s) => s.id);
        const items = [{ id: t.variant, quantity: 1 }];
        addons.forEach((a) => { if (a.checked) items.push({ id: Number(a.dataset.variant), quantity: 1 }); });
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections, sections_url: location.pathname })
        });
        let data;
        try { data = JSON.parse(await res.text()); } catch (x) { throw Error('Your ties could not be added. Please try again.'); }
        if (!res.ok || data.status) throw Error(data.description || data.message || 'Your ties could not be added. Please try again.');
        vipFirst();
        drawer.renderContents(data);
        let cart;
        try { cart = await Gift.sync(); } catch (ge) { err.textContent = ge.message; }
        if (!cart) cart = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        setCount(cart.item_count);
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.open(btn);
      } catch (x) {
        err.textContent = x.message || 'Please check your cart before trying again.';
        err.scrollIntoView({ block: 'center', behavior: smooth() });
      } finally {
        busy = false;
        buttons.forEach((b) => { b.removeAttribute('aria-busy'); b.disabled = false; });
        paint(false);
      }
    }
    document.querySelectorAll('[data-izt-add]').forEach((b) => b.addEventListener('click', add));
    root.querySelectorAll('[data-izt-cart]').forEach((b) => b.addEventListener('click', async () => {
      try {
        const d = await drawerReady();
        await Gift.sync();
        const ids = d.getSectionsToRender().map((s) => s.id);
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const [sections, c] = await Promise.all([
          fetch(base + '?sections=' + ids.join(',')).then((r) => r.json()),
          fetch(base + 'cart.js').then((r) => r.json())
        ]);
        d.renderContents({ id: 0, sections });
        d.classList.toggle('is-empty', c.item_count === 0);
        setCount(c.item_count);
        d.open(b);
      } catch (x) { root.querySelector('[data-izt-error]').textContent = x.message; }
    }));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(window.__iztSync);
        window.__iztSync = setTimeout(() => Gift.sync().then((c) => c && setCount(c.item_count)).catch((x) => {
          const e = document.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-izt-error]');
          if (e) e.textContent = x.message;
        }), 150);
      });
    }
    const nd = document.querySelector('cart-drawer');
    if (nd) new MutationObserver(() => {
      const q = [...nd.querySelectorAll('.cart-drawer-item .quantity__input')];
      if (q.length) setCount(q.reduce((n, i) => n + Number(i.value || 0), 0));
      else if (nd.classList.contains('is-empty')) setCount(0);
    }).observe(nd, { subtree: true, childList: true });
    document.addEventListener('click', (e) => {
      const b = e.target.closest('cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.iztReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      Gift.sync().then(() => {
        const n = document.querySelector('cart-drawer [name="checkout"]') || b;
        n.dataset.iztReady = '1'; n.click(); delete n.dataset.iztReady;
      }).catch((x) => {
        const el = document.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-izt-error]');
        if (el) el.textContent = x.message;
      });
    }, true);
    Gift.sync().then((c) => c && setCount(c.item_count)).catch(() => {});

    /* policy dialog */
    const dlg = document.querySelector('#izt-policy');
    if (dlg) {
      document.querySelectorAll('[data-izt-policy]').forEach((b) => b.addEventListener('click', () => dlg.showModal()));
      dlg.querySelector('[data-izt-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    }
    /* sample pill appears once the banner scrolls away */
    const cBan = document.querySelector('.iz-banner'), cPill = document.querySelector('.iz-concept-pill');
    if (cPill) {
      if (cBan && 'IntersectionObserver' in window) new IntersectionObserver((es) => cPill.classList.toggle('is-on', !es[0].isIntersecting)).observe(cBan);
      else cPill.classList.add('is-on');
    }
    /* sticky bar */
    const sticky = document.querySelector('[data-izt-sticky]'), buy = root.querySelector('.iz-buy .iz-atc');
    if (sticky && buy) {
      let sraf;
      const check = () => {
        cancelAnimationFrame(sraf);
        sraf = requestAnimationFrame(() => {
          const show = buy.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', String(!show));
          sticky.querySelector('button').tabIndex = show ? 0 : -1;
        });
      };
      addEventListener('scroll', check, { passive: true });
      addEventListener('resize', check);
      check();
    }
  }

  function widgets() {
    document.querySelectorAll('[data-izt-fit]').forEach((f) => {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      const tabs = [...f.querySelectorAll('[data-fx]')], ans = [...f.querySelectorAll('[data-fx-ans]')];
      tabs.forEach((b) => b.addEventListener('click', () => {
        tabs.forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
        ans.forEach((a) => (a.hidden = a.dataset.fxAns !== b.dataset.fx));
      }));
    });
  }

  const boot = () => { init(); widgets(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => {
    updateShipDates(); widgets();
    document.querySelectorAll('.iz-s[data-izt-reveal]').forEach((s) => s.classList.add('is-in'));
  });
})();
